<mat-tab-group
  class="file-view-tabs"
  [mat-stretch-tabs]="false"
  [selectedIndex]="selectedIndex"
  (selectedIndexChange)="onSelectedIndexChange($event)"
  aria-label="File views"
>
  <mat-tab label="Overview">
    <ng-template matTabContent>
      <app-file-overview
        [projectId]="projectId"
        [fileId]="fileId"
        (pageStatusesChange)="onPageStatusesChange($event)"
      ></app-file-overview>
    </ng-template>
  </mat-tab>
  <mat-tab label="Compliance">
    <ng-template matTabContent>
      <app-file-compliance-summary [projectId]="projectId" [fileId]="fileId"></app-file-compliance-summary>
    </ng-template>
  </mat-tab>
</mat-tab-group>
